import React from 'react';

const Home = () => {
  return (
    <section className='home'>
      <h2>Welcome to our page!</h2>
      <p>
        A <b>calculator</b> is a device that performs arithmetic operations on numbers. The simplest calculators can do only addition, subtraction, multiplication, and division. 
        More sophisticated calculators can handle exponent ial operations, roots, logarithm s, trigonometric functions, and hyperbolic functions. 
        Internally, some calculators actually perform all of these functions by repeated processes of addition.<br/>
        Most calculators these days require electricity to operate. 
        Portable, battery-powered calculators are popular with engineers and engineering students. 
        Before 1970, a more primitive form of calculator, the slide rule , was commonly used.<br/>
        It consisted of a slat of wood, called the slide, that could be moved in and out of a reinforced pair of slats. 
        Both the slide and the outer pair of slats had calibrated numerical scales. A movable, transparent sleeve called the cursor was used to align numerals on the scales. 
        The slide rule did not require any source of power, but its precision was limited, and it was necessary to climb a learning curve to become proficient with it.
        <br/><b><cite>(TechTarget Contributor, 2005)</cite></b>
      </p>
    </section>
  );
}

export default Home;
